// tslint:disable:no-any
// import {State as MainState} from 'FullVersion/Store'; TODO: move away from library
import {FeatureFlagProps, State} from './State';

export const selectSettingsStateFromMainState = (mainState: any): State => mainState.settingsState;

export const selectFeatureFlags = (state: any): FeatureFlagProps =>
    selectSettingsStateFromMainState(state).featureFlags;
